


















import { Component, Vue, Prop } from "vue-property-decorator";
import { format, parse } from "date-fns";
import { DATE_FORMAT } from "@/Constants";
import { DATE_PICKER_FORMAT } from "@/Constants";
import DatePicker from "@/components/Forms/DatePicker.vue";

@Component({ components: { DatePicker } })
export default class DateRangePicker extends Vue {
  isMenuOpen = false;
  @Prop({ default: [] }) readonly value?: string[];
  @Prop({ default: "Select a date range" }) readonly label?: string;
  @Prop({ default: false }) readonly disabled?: boolean;
  @Prop() readonly min?: string;
  @Prop() readonly max?: string;
  @Prop({ default: "" }) id?: string;
  dateRange: string[] = [];

  mounted() {
    this.$watch(
      () => this.value,
      () => {
        this.dateRange = this.value ?? [];
      }
    );

    this.$watch(
      () => this.isMenuOpen,
      () => {
        if (!this.isMenuOpen && this.dateRange.length) {
          this.onDatePickerChange(this.dateRange);
        }
      }
    );
  }

  get dateRangeText() {
    return this.sortedDateRange.map(x => format(new Date(x), DATE_FORMAT)).join(" — ");
  }

  get sortedDateRange() {
    if (!this.value) return [];
    return this.value.length <= 1 ? this.value : this.value.slice().sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
  }

  onDatePickerChange(value: string[]) {
    if (value.length >= 2) {
      const firstValue = value[0];
      const secondValue = value[1];

      const startDate = parse(firstValue, DATE_PICKER_FORMAT, new Date());
      const endDate = parse(secondValue, DATE_PICKER_FORMAT, new Date());

      if (endDate < startDate) {
        value[0] = secondValue;
        value[1] = firstValue;
      }
    }

    this.$emit("input", value);
  }

  setValue(dateRange: string[]) {
    this.$emit("input", dateRange);
  }
}
